// Comment NOMMER un persona à l'écran.
//
// Le RÔLE d'abord : c'est par type d'utilisateur qu'on lit les résultats
// (« le Magasinier n'arrive pas à… »), le prénom n'est qu'un repère pour s'y
// retrouver. Un persona sans rôle garde son prénom en titre.

interface Named {
  name: string;
  role?: string | null;
}

/** Ce qui s'affiche en titre : le rôle, sinon le prénom. */
export function personaTitle(p: Named): string {
  return p.role?.trim() || p.name;
}

/** Le prénom, en second, quand le rôle a pris le titre — sinon rien. */
export function personaAside(p: Named): string | null {
  return p.role?.trim() ? p.name : null;
}

/** Une ligne : « Magasinier — Karim », ou « Karim » sans rôle. */
export function personaLine(p: Named): string {
  const aside = personaAside(p);
  return aside ? `${personaTitle(p)} — ${aside}` : personaTitle(p);
}
